export default __webpack_public_path__ + "static/media/tusd.441ef2ec.png";